import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {CountyApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-counties',
  templateUrl: './counties.component.html',
  styleUrls: ['./counties.component.scss'],
  providers:[CountyApi,BaToastNotificationService]
})

@Injectable()
export class CountiesComponent implements OnInit {

  private countySource = new BehaviorSubject<object>({})
  county = this.countySource.asObservable();

  private countiesSource = new BehaviorSubject<object>([])
  counties = this.countiesSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected countyService:CountyApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getCounties(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getCounties(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getCounties(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.countyService.find({
      order: "id DESC",
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.countiesSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.countyService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.countyService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.countiesSource.next(results.data.counties);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateCountySource(data){
    this.countySource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.countySource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/counties/counties.component.ts